"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EdtechComponent = EdtechComponent;
exports["default"] = VideoSession;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _reactSdk = require("@100mslive/react-sdk");
var _reactUi = require("@100mslive/react-ui");
var _Notifications = require("./components/Notifications");
var _confetti = require("./plugins/confetti");
var _RemoteStopScreenshare = require("./plugins/RemoteStopScreenshare");
var _ToastContainer = require("./components/Toast/ToastContainer");
var _FullPageProgress = _interopRequireDefault(require("./components/FullPageProgress"));
var _KeyboardInputManager = require("./components/Input/KeyboardInputManager");
var _PostLeave = _interopRequireDefault(require("./components/PostLeave"));
var _AppData = require("./components/AppData/AppData");
var _ErrorBoundary = require("./components/ErrorBoundary");
var _ErrorPage = _interopRequireDefault(require("./components/ErrorPage"));
var _Init = require("./components/init/Init");
var _hms = require("./hms.js");
var _FeatureFlags = require("./services/FeatureFlags");
var _tokenService = require("./services/tokenService");
var _utils = require("./common/utils");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var Conference = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require("./components/conference"));
  });
});
var PreviewScreen = /*#__PURE__*/_react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require("./components/PreviewScreen"));
  });
});
var defaultTokenEndpoint = process.env.REACT_APP_TOKEN_GENERATION_ENDPOINT_DOMAIN ? "".concat((0, _tokenService.getBackendEndpoint)()).concat(process.env.REACT_APP_TOKEN_GENERATION_ENDPOINT_DOMAIN, "/") : process.env.REACT_APP_TOKEN_GENERATION_ENDPOINT;
var envPolicyConfig = JSON.parse(process.env.REACT_APP_POLICY_CONFIG || "{}");
var appName;
if (window.location.host.includes("localhost")) {
  appName = "localhost";
} else {
  appName = window.location.host.split(".")[0];
}
document.title = process.env.REACT_APP_TITLE || "".concat(appName, "'s ").concat(document.title);

// TODO: remove now that there are options to change to portrait
var getAspectRatio = function getAspectRatio(_ref) {
  var width = _ref.width,
    height = _ref.height;
  var host = process.env.REACT_APP_HOST_NAME || window.location.hostname;
  var portraitDomains = (process.env.REACT_APP_PORTRAIT_MODE_DOMAINS || "").split(",");
  if (portraitDomains.includes(host) && width > height) {
    return {
      width: height,
      height: width
    };
  }
  return {
    width: width,
    height: height
  };
};
function EdtechComponent(_ref2) {
  var _ref2$participantName = _ref2.participantName,
    participantName = _ref2$participantName === void 0 ? "Unknown User" : _ref2$participantName,
    _ref2$tokenEndpoint = _ref2.tokenEndpoint,
    tokenEndpoint = _ref2$tokenEndpoint === void 0 ? defaultTokenEndpoint : _ref2$tokenEndpoint,
    _ref2$themeConfig = _ref2.themeConfig,
    _ref2$themeConfig$asp = _ref2$themeConfig.aspectRatio,
    aspectRatio = _ref2$themeConfig$asp === void 0 ? "1-1" : _ref2$themeConfig$asp,
    _ref2$themeConfig$fon = _ref2$themeConfig.font,
    font = _ref2$themeConfig$fon === void 0 ? "Roboto" : _ref2$themeConfig$fon,
    _ref2$themeConfig$col = _ref2$themeConfig.color,
    color = _ref2$themeConfig$col === void 0 ? "#2F80FF" : _ref2$themeConfig$col,
    _ref2$themeConfig$the = _ref2$themeConfig.theme,
    theme = _ref2$themeConfig$the === void 0 ? "dark" : _ref2$themeConfig$the,
    _ref2$themeConfig$log = _ref2$themeConfig.logo,
    logo = _ref2$themeConfig$log === void 0 ? "" : _ref2$themeConfig$log,
    _ref2$themeConfig$hea = _ref2$themeConfig.headerPresent,
    headerPresent = _ref2$themeConfig$hea === void 0 ? "false" : _ref2$themeConfig$hea,
    _ref2$themeConfig$met = _ref2$themeConfig.metadata,
    metadata = _ref2$themeConfig$met === void 0 ? "" : _ref2$themeConfig$met,
    _ref2$themeConfig$rec = _ref2$themeConfig.recordingUrl,
    recordingUrl = _ref2$themeConfig$rec === void 0 ? "" : _ref2$themeConfig$rec,
    _ref2$policyConfig = _ref2.policyConfig,
    policyConfig = _ref2$policyConfig === void 0 ? envPolicyConfig : _ref2$policyConfig;
  var _aspectRatio$split$ma = aspectRatio.split("-").map(function (el) {
      return parseInt(el);
    }),
    width = _aspectRatio$split$ma[0],
    height = _aspectRatio$split$ma[1];
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ErrorBoundary.ErrorBoundary, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.HMSThemeProvider, {
      themeType: theme,
      aspectRatio: getAspectRatio({
        width: width,
        height: height
      }),
      theme: {
        colors: {
          brandDefault: color,
          brandDark: (0, _utils.shadeColor)(color, -30),
          brandLight: (0, _utils.shadeColor)(color, 30),
          brandDisabled: (0, _utils.shadeColor)(color, 10)
        },
        fonts: {
          sans: [font, "Inter", "sans-serif"]
        }
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactSdk.HMSRoomProvider, {
        isHMSStatsOn: _FeatureFlags.FeatureFlags.enableStatsForNerds,
        actions: _hms.hmsActions,
        store: _hms.hmsStore,
        notifications: _hms.hmsNotifications,
        stats: _hms.hmsStats,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_AppData.AppData, {
          participantName: participantName,
          appDetails: metadata,
          policyConfig: policyConfig,
          recordingUrl: recordingUrl,
          logo: logo,
          tokenEndpoint: tokenEndpoint
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Init.Init, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Box, {
          css: _objectSpread({
            bg: "$mainBg",
            w: "100%"
          }, headerPresent === "true" ? {
            flex: "1 1 0",
            minHeight: 0
          } : {
            h: "100%"
          }),
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(AppRoutes, {})
        })]
      })
    })
  });
}
var RedirectToPreview = function RedirectToPreview() {
  var _useParams = (0, _reactRouterDom.useParams)(),
    sessionId = _useParams.sessionId,
    token = _useParams.token;
  if (!token) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.Navigate, {
      to: "/"
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.Navigate, {
    to: "".concat((0, _utils.getRoutePrefix)(), "/").concat(sessionId, "/preview/").concat(token)
  });
};
var RedirectToConsultationDetails = function RedirectToConsultationDetails() {
  var _useParams2 = (0, _reactRouterDom.useParams)(),
    sessionId = _useParams2.sessionId;
  if (!sessionId) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.Navigate, {
      to: "/"
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.Navigate, {
    to: "/consultation/".concat(sessionId, "/preview/").concat(token)
  });
};
var RouteList = function RouteList() {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactRouterDom.Routes, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.Route, {
      path: "/:sessionId/preview/:token",
      element: /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Suspense, {
        fallback: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FullPageProgress["default"], {}),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(PreviewScreen, {})
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.Route, {
      path: "/:sessionId/meeting/:token",
      element: /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Suspense, {
        fallback: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FullPageProgress["default"], {}),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Conference, {})
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactRouterDom.Route, {
      path: "/:sessionId/leave",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.Route, {
        path: ":roomId/:role",
        element: /*#__PURE__*/(0, _jsxRuntime.jsx)(_PostLeave["default"], {})
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.Route, {
        path: ":roomId",
        element: /*#__PURE__*/(0, _jsxRuntime.jsx)(_PostLeave["default"], {})
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.Route, {
      path: "/:sessionId/:token",
      element: /*#__PURE__*/(0, _jsxRuntime.jsx)(RedirectToPreview, {})
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.Route, {
      path: "*",
      element: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ErrorPage["default"], {
        error: "Invalid URL!"
      })
    })]
  });
};
function AppRoutes() {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ToastContainer.ToastContainer, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Notifications.Notifications, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_confetti.Confetti, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_RemoteStopScreenshare.RemoteStopScreenshare, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_KeyboardInputManager.KeyboardHandler, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(RouteList, {})]
  });
}
function VideoSession(_ref3) {
  var participantName = _ref3.participantName;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(EdtechComponent, {
    participantName: participantName,
    themeConfig: {
      aspectRatio: process.env.REACT_APP_TILE_SHAPE,
      theme: process.env.REACT_APP_THEME,
      color: process.env.REACT_APP_COLOR,
      logo: process.env.REACT_APP_LOGO,
      font: process.env.REACT_APP_FONT,
      headerPresent: process.env.REACT_APP_HEADER_PRESENT,
      metadata: process.env.REACT_APP_DEFAULT_APP_DETAILS // A stringified object in env
    }
  });
}